import { useEffect } from 'react';
import { useWebSocket } from '@/utils/contexts/WebSocketContext';

interface WebSocketMessage {
  event: string;
  video_id?: string;
  timestamp?: string;
  data?: {
    content_type?: 'video' | 'image' | 'transcript';
    sender_role?: 'admin' | 'user';
    sender_email?: string;
    user_email?: string;
    video_info?: any;
    image_info?: any;
    video_id?: string;
    message?: string;
    type?: string;
    video_data?: any;
    [key: string]: any;
  };
  message?: string;
  user_email?: string;
  video_info?: any;
  status?: string;
  room_type?: string;
  identifier?: string;
}

interface UseSharedWebSocketReturn {
  isConnected: boolean;
  connectionError: string | null;
  pinVideoWebSocket: (videoId: string, userEmail?: string) => void;
  unpinVideoWebSocket: (videoId: string, userEmail?: string) => void;
  sendMessage: (message: any) => void;
  reconnect: () => void;
  userEmail: string | null;
  isAdmin: boolean;
}

/**
 * Hook to use the shared WebSocket connection
 * This replaces the individual useVideoWebSocket hooks to prevent multiple connections
 */
const useSharedWebSocket = (
  componentId: string,
  onMessage: (data: WebSocketMessage) => void
): UseSharedWebSocketReturn => {
  const {
    isConnected,
    connectionError,
    subscribe,
    unsubscribe,
    sendMessage,
    pinVideoWebSocket,
    unpinVideoWebSocket,
    reconnect,
    userEmail,
    isAdmin
  } = useWebSocket();

  // Subscribe to messages when component mounts
  useEffect(() => {
    subscribe(componentId, onMessage);
    
    return () => {
      unsubscribe(componentId);
    };
  }, [componentId, onMessage, subscribe, unsubscribe]);

  return {
    isConnected,
    connectionError,
    pinVideoWebSocket,
    unpinVideoWebSocket,
    sendMessage,
    reconnect,
    userEmail,
    isAdmin
  };
};

export default useSharedWebSocket;